import { AppConfiguration } from "config";
import React, { useEffect, useState } from 'react';
// import Breadcrumbs from 'components/Common/Breadcrumb';
import MetaTags from 'react-meta-tags';
import {
    Col, Container, Row,
    TabPane, TabContent, CardBody, Card
} from "reactstrap";
import LeadSnapshot from "components/Common/LeadDetail/LeadSnapshot";
import {
    useLocation, useParams,
} from 'react-router-dom';
import LeadDrivers from "components/Common/LeadDetail/LeadDrivers";
import LeadVehicles from "components/Common/LeadDetail/LeadVehicles";
import LeadCoverage from "components/Common/LeadDetail/LeadCoverage";
import LeadViolations from "components/Common/LeadDetail/LeadViolations";
import { useDispatch, useSelector } from "react-redux";
import LeadHomes from "components/Common/LeadDetail/LeadHome";
import LeadBusinessEntity from "components/Common/LeadDetail/LeadBusinessEntity";
import LeadDetailLoading from "components/Common/Loadings/LeadSnapshotLoading";
import LeadSubSectionLoading from "components/Common/Loadings/LeadSubSectionLoading";
import LeadNavLinkLoading from "components/Common/Loadings/LeadNavLinkLoading";
import LeadClaims from "components/Common/LeadDetail/LeadClaims";
import CallTranscription from "pages/CallsTranscription/CallTranscription";
import BreadCrumbProspect from "components/Common/BreadCrumbProspect";
import { getProspectById, getProspectDetailReport } from "store/prospects/actions";
import SfNavLink from "components/Common/SfNavLink";
import useFeatureFlags from "hooks/useFeatureFlags";
import { PRODUCT_TYPE_IDS, PROSPECT_TABS, REQUIRED_FEATURE_FLAGS } from "helpers/sf_constants";
import Consent from "pages/Prospects/Consent";
import CallSummary from "./call-summary/CallSummary";
import { CSVExport } from "react-bootstrap-table2-toolkit";
import { getLeadRefundReasons } from "store/leads/lead_refund_reasons_actions";
import useSingleActionDispatcher from "hooks/useSingleActionDispatcher";

const searchParams = new URLSearchParams(location.search);

const ProspectDetail = (props) => {

    const dispatch = useDispatch()
    //Create a state for lead_type
    const location = useLocation();
    const [lead_data, setLeadData] = useState({})
    const [showTranscription, setShowTranscription] = useState(false);
    const { lead_id } = useParams();
    const {
        leads,
        loading,
        current_account,
        lead_refund_reasons,
        consent
    } = useSelector(state => ({
        leads: state.Prospects.leads,
        loading: state.Leads.loading,
        current_account: state.accounts.current_account,
        lead_refund_reasons: state.Leads.lead_refund_reasons,
        consent: state.Prospects.consent
    })
    );
    const [activeTab, setActiveTab] = useState('overview');
    const isCallFromProspects = lead_data?.qf_quote_call?.id ? true : false //Change this regarding to the backend data
    const isProspects = true;

    const [isFeatureFlagActive] = useFeatureFlags();
    const { ExportCSVButton } = CSVExport;
    const new_consent_ui_ff = isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_ENABLE_CUSTOM_CONSENT_UI)
    const isLeadMarketplace = lead_data?.product_type_id === PRODUCT_TYPE_IDS.LEADS
    const showConsentTab = !isLeadMarketplace && new_consent_ui_ff && lead_data?.lead_detail?.consent_certificate_id

    useSingleActionDispatcher(getLeadRefundReasons());

    //Create a useEffect and get lead data from redux store from lead_id from useParams
    useEffect(() => {
        if (leads.length > 0) {
            const lead = leads.find(lead => lead.id === parseInt(lead_id));
            setLeadData(lead);
        }

    }, [leads])

    useEffect(() => {
        if (lead_id) {
            dispatch(getProspectById({ id: lead_id }))
        }
    }, [lead_id])

    const [customActiveTab, setcustomActiveTab] = useState('1');

    const toggleCustom = (tab) => {
        if (customActiveTab !== tab) {
            setcustomActiveTab(tab);
        }
    };

    useEffect(() => {
        if (location) {
            if (lead_data?.lead_type_id === 1) { //home
                if (location.hash.includes('applicants')) {
                    setcustomActiveTab('1');
                }
                if (location.hash.includes('homes')) {
                    setcustomActiveTab('2');
                }
                if (location.hash.includes('existing-coverage')) {
                    setcustomActiveTab('3');
                }
                if (location.hash.includes('claims')) {
                    setcustomActiveTab('4');
                }
            }
            if (lead_data?.lead_type_id === 2) { //life

                if (location.hash.includes('applicants')) {
                    setcustomActiveTab('1');
                }
                if (location.hash.includes('existing-coverage')) {
                    setcustomActiveTab('2');
                }
            }
            if (lead_data?.lead_type_id === 3) { //health
                if (location.hash.includes('applicants')) {
                    setcustomActiveTab('1');
                }
                if (location.hash.includes('existing-coverage')) {
                    setcustomActiveTab('2');
                }
            }
            if (lead_data?.lead_type_id === 4) { //renters
                if (location.hash.includes('applicants')) {
                    setcustomActiveTab('1');
                }
                if (location.hash.includes('existing-coverage')) {
                    setcustomActiveTab('2');
                }
            }
            if (lead_data?.lead_type_id === 5) { //commercial
                if (location.hash.includes('applicants')) {
                    setcustomActiveTab('1');
                }
                if (location.hash.includes('business-entity')) {
                    setcustomActiveTab('2');
                }
                if (location.hash.includes('existing-coverage')) {
                    setcustomActiveTab('3');
                }
            }
            if (lead_data?.lead_type_id === 6) { //auto
                if (location.hash.includes('driver')) {
                    setcustomActiveTab('1');
                }
                if (location.hash.includes('vehicles')) {
                    setcustomActiveTab('2');
                }
                if (location.hash.includes('existing-coverage')) {
                    setcustomActiveTab('3');
                }
                if (location.hash.includes('violations')) {
                    setcustomActiveTab('4');
                }
            }
            if (lead_data?.lead_type_id === 7) { //medicare
                if (location.hash.includes('applicants')) {
                    setcustomActiveTab('1');
                }
                if (location.hash.includes('existing-coverage')) {
                    setcustomActiveTab('2');
                }
            }
        }
    }, [location, lead_data]);


    const handleButtonClickOverview = () => {
        setActiveTab('overview');
        setShowTranscription(false);
    };

    const handleButtonClickTranscription = () => {
        setActiveTab('transcription');
        setShowTranscription(true);
    };
    const handleButtonClickConsent = () => {
        setActiveTab('consent');
        setShowTranscription(false);

    };
    const handleButtonClickSummary = () => {
        setActiveTab(PROSPECT_TABS.SUMMARY);
        setShowTranscription(false);
    };

    const handleButtonClickExport = () => {
        const queryParams = {};
        queryParams.lead_id = lead_id;
        queryParams.lead_type_id = lead_data?.lead_type_id;
        queryParams.product_type_id = lead_data?.product_type_id;
        dispatch(getProspectDetailReport({ queryParams }, 'Prospect_detail.csv'));
    }


    return (
        <div className="page-content" id="page-content-wrapper">
            <MetaTags>
                <title>Details | {AppConfiguration.WEBSITE}</title>
            </MetaTags>
            <Container fluid>
                <BreadCrumbProspect
                    backOption
                    link={'/prospects'}
                    breadcrumbItem="Prospect Details"
                    activeTab={activeTab}
                    handleButtonClickOverview={handleButtonClickOverview}
                    handleButtonClickTranscription={handleButtonClickTranscription}
                    handleButtonClickConsent={handleButtonClickConsent}
                    handleButtonClickSummary={handleButtonClickSummary}
                    isCallFromProspects={isCallFromProspects}
                    isConsent={showConsentTab}
                    current_account={current_account}
                />
                {/* Change this Component later */}
                {showTranscription ?
                    <CallTranscription lead_id={lead_id} is_prospect={isProspects} />
                    :
                    activeTab === PROSPECT_TABS.CONSENT && showConsentTab ?
                        <Consent consent_certificate_id={lead_data?.lead_detail?.consent_certificate_id} />
                        :
                        <Row>
                            <Col xl={3}>
                                {loading ?
                                    <LeadDetailLoading /> :
                                    <LeadSnapshot
                                        current_account={current_account}
                                        lead_refund_reasons={lead_refund_reasons}
                                        lead_data={lead_data}
                                        show_recording_for_prospect={isCallFromProspects}
                                        is_prospect={isProspects}
                                    />
                                }
                            </Col >
                            {activeTab === PROSPECT_TABS.SUMMARY ?
                                <Col xl={9}>
                                    <Card>
                                        <CardBody>
                                            <CallSummary lead_id={lead_id} />
                                        </CardBody>
                                    </Card>
                                </Col>
                                :
                                <Col xl={9}>
                                    <Row>
                                        <Col>
                                            {loading ? <LeadNavLinkLoading /> :
                                                <div className="d-flex justify-content-between">
                                                    <ul className="nav sfnav mb-4">
                                                        <li className="nav-item">
                                                            <SfNavLink
                                                                position="1"
                                                                location={lead_data?.lead_type_id === 6 ? '#drivers' : '#applicants'}
                                                                tabName={lead_data?.lead_type_id === 6 ? 'Drivers' : 'Applicants'}
                                                                customActiveTab={customActiveTab}
                                                                setcustomActiveTab={setcustomActiveTab}
                                                            />
                                                        </li>

                                                        <li className="nav-item">
                                                            <SfNavLink
                                                                position="2"
                                                                location={lead_data?.lead_type_id === 1 ? '#homes' : lead_data?.lead_type_id === 5 ? "#business-entity" : lead_data?.lead_type_id === 6 ? "#vehicles" : '#existing-coverage'}
                                                                tabName={lead_data?.lead_type_id === 1 ? 'Homes' :
                                                                    lead_data?.lead_type_id === 5 ? "Business Entity" :
                                                                        lead_data?.lead_type_id === 6 ? "Vehicles" :
                                                                            'Existing Coverage'}
                                                                customActiveTab={customActiveTab}
                                                                setcustomActiveTab={setcustomActiveTab}
                                                            />
                                                        </li>

                                                        {lead_data?.lead_type_id === 1 &&
                                                            <li className="nav-item">
                                                                <SfNavLink
                                                                    position="3"
                                                                    location="#existing-coverage"
                                                                    tabName='Existing Coverage'
                                                                    customActiveTab={customActiveTab}
                                                                    setcustomActiveTab={setcustomActiveTab}
                                                                />
                                                            </li>
                                                        }

                                                        {lead_data?.lead_type_id === 5 &&
                                                            <li className="nav-item">
                                                                <SfNavLink
                                                                    position="3"
                                                                    location="#existing-coverage"
                                                                    tabName='Existing Coverage'
                                                                    customActiveTab={customActiveTab}
                                                                    setcustomActiveTab={setcustomActiveTab}
                                                                />
                                                            </li>
                                                        }

                                                        {lead_data?.lead_type_id === 6 &&
                                                            <li className="nav-item">
                                                                <SfNavLink
                                                                    position="3"
                                                                    location="#existing-coverage"
                                                                    tabName='Existing Coverage'
                                                                    customActiveTab={customActiveTab}
                                                                    setcustomActiveTab={setcustomActiveTab}
                                                                />
                                                            </li>}

                                                        {lead_data?.lead_type_id === 1 &&
                                                            <li className="nav-item">
                                                                <SfNavLink
                                                                    position="4"
                                                                    location="#claims"
                                                                    tabName='Claims'
                                                                    customActiveTab={customActiveTab}
                                                                    setcustomActiveTab={setcustomActiveTab}
                                                                />
                                                            </li>}

                                                        {lead_data?.lead_type_id === 6 &&
                                                            <li className="nav-item">
                                                                <SfNavLink
                                                                    position="4"
                                                                    location="#violations"
                                                                    tabName='Violations'
                                                                    customActiveTab={customActiveTab}
                                                                    setcustomActiveTab={setcustomActiveTab}
                                                                />
                                                            </li>}
                                                    </ul>
                                                    {isFeatureFlagActive(REQUIRED_FEATURE_FLAGS?.SF_FEATURE_FLAG_LEAD_DETAIL_EXPORT) && (
                                                        <ExportCSVButton
                                                            type="button" className={`btn btn-outline-sfblue w-md`} style={{ height: '40px' }} onClick={() => handleButtonClickExport()}>
                                                            <i className="bx bx-import font-size-14 align-middle me-2" />
                                                            Export
                                                        </ExportCSVButton>
                                                    )}
                                                </div>
                                            }
                                            <TabContent activeTab={customActiveTab}>
                                                <TabPane tabId="1">
                                                    {loading ? <LeadSubSectionLoading /> :
                                                        <LeadDrivers is_prospect={isProspects} lead_data={lead_data} />}
                                                </TabPane>
                                                <TabPane tabId="2">
                                                    {lead_data?.lead_type_id === 1 ? loading
                                                        ? <LeadSubSectionLoading />
                                                        : <LeadHomes is_prospect={isProspects} lead_data={lead_data} />
                                                        : null
                                                    }
                                                    {lead_data?.lead_type_id === 2 ? loading
                                                        ? <LeadSubSectionLoading />
                                                        : <LeadCoverage is_prospect={isProspects} lead_data={lead_data} />
                                                        : null
                                                    }
                                                    {lead_data?.lead_type_id === 3 ? loading
                                                        ? <LeadSubSectionLoading />
                                                        : <LeadCoverage is_prospect={isProspects} lead_data={lead_data} />
                                                        : null
                                                    }
                                                    {lead_data?.lead_type_id === 4 ? loading
                                                        ? <LeadSubSectionLoading />
                                                        : <LeadCoverage is_prospect={isProspects} lead_data={lead_data} />
                                                        : null
                                                    }
                                                    {lead_data?.lead_type_id === 5 ? loading
                                                        ? <LeadSubSectionLoading />
                                                        : <LeadBusinessEntity is_prospect={isProspects} lead_data={lead_data} />
                                                        : null
                                                    }
                                                    {lead_data?.lead_type_id === 6 ? loading
                                                        ? <LeadSubSectionLoading />
                                                        : <LeadVehicles is_prospect={isProspects} lead_data={lead_data} />
                                                        : null
                                                    }
                                                    {lead_data?.lead_type_id === 7 ? loading
                                                        ? <LeadSubSectionLoading />
                                                        : <LeadCoverage is_prospect={isProspects} lead_data={lead_data} />
                                                        : null
                                                    }
                                                </TabPane>
                                                <TabPane tabId="3">
                                                    {loading
                                                        ? <LeadSubSectionLoading />
                                                        : <LeadCoverage is_prospect={isProspects} lead_data={lead_data} />
                                                    }
                                                </TabPane>
                                                <TabPane tabId="4">
                                                    {lead_data?.lead_type_id === 6 ? loading
                                                        ? <LeadSubSectionLoading />
                                                        : <LeadViolations is_prospect={isProspects} lead_data={lead_data} />
                                                        : null
                                                    }
                                                    {lead_data?.lead_type_id === 1 ? loading
                                                        ? <LeadSubSectionLoading />
                                                        : <LeadClaims is_prospect={isProspects} lead_data={lead_data} />
                                                        : null
                                                    }
                                                </TabPane>
                                            </TabContent>
                                        </Col>
                                    </Row>
                                </Col>
                            }
                        </Row >
                }
            </Container >
        </div >
    )
}

export default ProspectDetail;